<template>
  <v-card>
    <v-row class="overflow-hidden mx-0">
      <v-col
        cols="12"
        class="pa-0"
        v-bind:style="{ backgroundColor: '#F7F9FA' }"
      >
        <v-container class="py-2 px-6">
          <v-row>
            <v-col cols="auto">
              <slot name="avatar"></slot>
            </v-col>
            <v-col cols="auto" class="my-auto">
              <div class="lighttext--text">
                <v-row>
                  <v-col cols="auto" class="font-weight-bold py-0">
                    <slot name="headerLine1"></slot>
                  </v-col>
                  <v-col cols="auto" class="darkaccent--text py-0">
                    <slot name="headerLine1Chip"></slot>
                  </v-col>
                </v-row>
              </div>
              <div class="subtitle-2 darkaccent--text">
                <slot name="headerLine2"></slot>
              </div>
            </v-col>
            <slot name="headerAppend"> </slot>
          </v-row>
        </v-container>
      </v-col>
    </v-row>
    <v-divider></v-divider>
    <v-row class="overflow-hidden mx-0">
      <v-col cols="12" class="py-0 px-4">
        <slot></slot>
      </v-col>
    </v-row>
  </v-card>
</template>

<script>
export default {
  name: "DetailsHeader"
};
</script>
